import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "How does instant delivery work?",
    a: "After payment, our system automatically assigns a license key from our verified inventory and shows it on the success page. A copy is also emailed to you. For Autodesk subscriptions, our team activates the license against your Autodesk account email within a few minutes — no key required.",
  },
  {
    q: "Are these keys genuine?",
    a: "Yes. We source all licenses from authorized partners. No patched, no cracked, no grey-market keys. Every Microsoft and antivirus key activates online directly against the vendor.",
  },
  {
    q: "How are Autodesk products different?",
    a: "Autodesk licenses are subscription-based and tied to your Autodesk account. Instead of receiving a key, you provide your Autodesk account email at checkout, and we activate the 1-year subscription on that account. You log into Autodesk normally with your own credentials.",
  },
  {
    q: "Why are your prices so much lower than Autodesk's official pricing?",
    a: "We work with regional and educational partners, buy in volume, and pass the savings on. Pricing is honest and consistent — no fake discounts.",
  },
  {
    q: "What payment methods do you accept?",
    a: "All major credit cards and digital wallets through Stripe — encrypted, PCI-compliant, and secure.",
  },
  {
    q: "Can I install the software on multiple devices?",
    a: "It depends on the license. Microsoft retail keys typically allow 1 PC activation. Antivirus packages cover 3-5 devices. Autodesk single-user subscriptions are personal and follow Autodesk's terms.",
  },
  {
    q: "What if my key doesn't work?",
    a: "Contact us through WhatsApp, iMessage or email immediately and we'll replace it within hours. Refund options are also available.",
  },
  {
    q: "Will my license expire?",
    a: "Microsoft Windows and Office retail keys are perpetual (lifetime). Antivirus and Autodesk subscriptions expire after the stated period (typically 1 year), after which you can renew.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-page" className="max-w-3xl mx-auto px-6 py-16">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// faq</div>
      <h1 className="font-heading font-bold text-4xl md:text-5xl mt-2">Questions, answered.</h1>
      <p className="text-[#A1A1AA] mt-3">If you don't find your answer here, ping us via WhatsApp or email.</p>

      <div className="mt-10 space-y-3">
        {FAQS.map((f, i) => (
          <div key={i} data-testid={`faq-item-${i}`} className="surface overflow-hidden">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="font-heading font-semibold">{f.q}</span>
              <ChevronDown className={`w-4 h-4 text-[#00FF66] shrink-0 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-[#A1A1AA] text-sm leading-relaxed border-t border-[#1E293B] pt-4">
                {f.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
